<template>
  <div v-if="blogElement" class="blog-detail-share">
    <p class="blog-detail-share__text">{{ messages.share }}:</p>
    <DefShare :result="blogElement.shareLinks" />
  </div>
</template>

<script lang="ts" setup>
import DefShare from '@components/Def/DefShare/DefShare.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const resultsStore = useResultsStore();

const messages = computed(() => resultsStore?.messages?.blog);
const blogElement = computed(() => resultsStore?.blogElement);
</script>

<style lang="scss" scoped>
.blog-detail-share {
  display: flex;
  align-items: center;
  &__text {
    font-weight: 500;
    font-size: 12px;
    margin-right: 12px;
  }
  :deep(.def-share) {
    grid-column-gap: 12px;
  }
  :deep(.def-share__icon) {
    width: 16px;
    height: 16px;
  }
}
</style>
